import { isString } from 'lodash-es';
export var GenericReason;
(function (GenericReason) {
    GenericReason[GenericReason["UNKNOWN"] = 0] = "UNKNOWN";
    GenericReason[GenericReason["UNEXPECTED"] = 1] = "UNEXPECTED";
})(GenericReason || (GenericReason = {}));
export default class BaseError extends Error {
    constructor(reason, messageOrOriginalError, originalError, httpStatusCode) {
        super(isString(messageOrOriginalError) ? messageOrOriginalError : undefined);
        this.reason = reason;
        this.originalError = originalError;
        this.httpStatusCode = httpStatusCode;
        if (!isString(messageOrOriginalError)) {
            this.originalError = {
                ...messageOrOriginalError,
                message: messageOrOriginalError.message,
                stack: messageOrOriginalError.stack,
                stacktrace: messageOrOriginalError.stacktrace
            };
        }
    }
}
//# sourceMappingURL=index.js.map